import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/styles/subscription.css";
import PlanCard from "./planCard";
import UsageCard from "./UsageCard";
import InfoCards from "./InfoCard";
import RightCards from "./RightCards";
import { useViewSubscription } from "../../hooks/subscription/subscription.view";
import {
  getSubscriptionRecord,
  hasActiveSubscription,
  hasSubscriptionEnded,
} from "./subscriptionUtils";
import { getPageTitle } from "../../utils/getPageTitle";

const Subscription = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useViewSubscription();
  const subscription = getSubscriptionRecord(data);
  const subscriptionIsActive = hasActiveSubscription(subscription);
  const subscriptionHasEnded = hasSubscriptionEnded(subscription);
  const hasPreviousPlan = Boolean(
    subscription?.plan || subscription?.planId || subscription?.planCode || subscription?.planName
  );
  const canRenew = subscriptionHasEnded && hasPreviousPlan;

  return (
    <div className="subscription-page">
      <div className="page-body subscription-page-header">
        <div className="page-header">
          <h1 className="page-title">{getPageTitle(location.pathname)}</h1>
          <p className="subscription-page-subtitle">
            Manage your subscription and billing
          </p>
        </div>
      </div>

      {!isLoading && !isError && !subscriptionIsActive ? (
        <section className="subscription-empty-state">
          <h2>{canRenew ? "Subscription ended" : "No active subscription"}</h2>
          <p>
            {canRenew
              ? "Your previous plan has expired. Renew it or choose another plan."
              : "Compare the available plans and choose one for your company."}
          </p>
          <button
            type="button"
            className="renew-btn"
            onClick={() => navigate("/plans")}
          >
            {canRenew ? "Renew plan" : "Browse plans"}
          </button>
        </section>
      ) : (
        <div className="dashboard-grid">
          <div className="left-section">
            <PlanCard
              subscription={subscription}
              isLoading={isLoading}
              isError={isError}
            />
            <UsageCard
              subscription={subscription}
              isLoading={isLoading}
              isError={isError}
            />
            <InfoCards
              subscription={subscription}
              isLoading={isLoading}
              isError={isError}
            />
          </div>

          <RightCards
            subscription={subscription}
            isLoading={isLoading}
            isError={isError}
          />
        </div>
      )}
    </div>
  );
};

export default Subscription;
